import { useFleetTrackerCanvasStore } from '../store/useFleetTrackerCanvasStore';
import { useFleetTrackerPlaybackStore } from '../store/useFleetTrackerPlaybackStore';
import { usePlayStore } from '../store/usePlayStore';
import { IFleetTrackerPlaybackService } from './IFleetTrackerPlaybackService';
import { FleetTrackerPlaybackServiceImpl } from './FleetTrackerPlaybackServiceImpl';
import { FleetTrackerPlaybackServiceExceptionDecorator } from './FleetTrackerPlaybackServiceExceptionDecorator';
import { FleetTrackerPlaybackServiceLogDecorator } from './FleetTrackerPlaybackServiceLogDecorator';

export class FleetTrackerPlaybackServiceFactory {
  private static instance: FleetTrackerPlaybackServiceFactory | null = null;
  private playbackStore: typeof useFleetTrackerPlaybackStore;
  private canvasStore: typeof useFleetTrackerCanvasStore;
  private playStore: typeof usePlayStore;

  // Shared instance: the service holds the throttle state of the playback time for all consumers
  private playbackService: IFleetTrackerPlaybackService | null = null;

  public static initialize(
    playbackStore: typeof useFleetTrackerPlaybackStore,
    canvasStore: typeof useFleetTrackerCanvasStore,
    playStore: typeof usePlayStore,
  ) {
    FleetTrackerPlaybackServiceFactory.instance = new FleetTrackerPlaybackServiceFactory(
      playbackStore,
      canvasStore,
      playStore,
    );
  }

  public static getInstance() {
    if (FleetTrackerPlaybackServiceFactory.instance === null) {
      throw new Error(
        'FleetTrackerPlaybackServiceFactory not yet initialized. Call FleetTrackerPlaybackServiceFactory.initialize() first.',
      );
    }
    return FleetTrackerPlaybackServiceFactory.instance;
  }

  private constructor(
    playbackStore: typeof useFleetTrackerPlaybackStore,
    canvasStore: typeof useFleetTrackerCanvasStore,
    playStore: typeof usePlayStore,
  ) {
    this.playbackStore = playbackStore;
    this.canvasStore = canvasStore;
    this.playStore = playStore;
  }

  public createFleetTrackerPlaybackService(): IFleetTrackerPlaybackService {
    if (!this.playbackService) {
      let result: IFleetTrackerPlaybackService = this.makeFleetTrackerPlaybackService();

      result = new FleetTrackerPlaybackServiceExceptionDecorator(result);
      result = new FleetTrackerPlaybackServiceLogDecorator(result);

      this.playbackService = result;
    }

    return this.playbackService;
  }

  private makeFleetTrackerPlaybackService(): IFleetTrackerPlaybackService {
    return new FleetTrackerPlaybackServiceImpl(
      this.playbackStore,
      this.canvasStore,
      this.playStore,
    );
  }
}
